import ApiRoutes, { baseUrl } from "../config/endpoints"
import HttpClient from "./index"
import { xApiKey } from "../config/endpoints"
import { xApiIv } from "../config/endpoints"
import moment from "moment"

class AuthAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  create = ApiRoutes?.Auth?.Create
  login = ApiRoutes?.Auth?.Login
  createPassword = ApiRoutes?.Auth?.CreatePassword
  verifyEmail = ApiRoutes?.Auth?.VerifyEmail
  changePassword = ApiRoutes?.Auth?.ChangePassword
  forgotPassword = ApiRoutes?.Auth?.ForgotPassword
  resetPassword = ApiRoutes?.Auth?.ResetPassword
  loginConfig = ApiRoutes?.Auth?.AdminLogin
  assignPerm = ApiRoutes?.Auth?.AssignPerm
  removePerm = ApiRoutes?.Auth?.RemovePerm
  userRole = ApiRoutes?.Auth?.UserRole

  userCreate = (token: string, data: any) => {
    return this.instance({
      method: this.create.Method,
      url: this.create.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    })
  }

  userLogin = async (email: string, password: string) => {
    return this.instance({
      method: this.login.Method,
      url: this.login.EndPoint,
      headers: { "x-api-key": xApiKey, "x-api-iv": xApiIv },
      data: {
        email: email,
        password: password,
        timestamp: moment.utc().toISOString(),
      },
    })
  }
  userCreatePassword = async (
    email: any,
    oldPassword: string,
    newPassword: string,
  ) => {
    return this.instance({
      method: this.createPassword.Method,
      url: this.createPassword.EndPoint,
      headers: { "x-api-key": xApiKey, "x-api-iv": xApiIv },
      data: {
        email: email,
        password: oldPassword,
        new_password: newPassword,
      },
    })
  }
  userVerifyEmail = async (email: string, password: string, code: string) => {
    return this.instance({
      method: this.verifyEmail.Method,
      url: this.verifyEmail.EndPoint,
      headers: { "x-api-key": xApiKey, "x-api-iv": xApiIv },
      data: {
        email: email,
        password: password,
        code: code,
      },
    })
  }
  userChangePassword = async (
    email: string,
    oldPassword: string,
    newPassword: string,
  ) => {
    return this.instance({
      method: this.changePassword.Method,
      url: this.changePassword.EndPoint,
      headers: { "x-api-key": xApiKey, "x-api-iv": xApiIv },
      data: {
        email: email,
        password: oldPassword,
        new_password: newPassword,
      },
    })
  }
  userForgotPassword = async (email: string) => {
    return this.instance({
      method: this.forgotPassword.Method,
      url: this.forgotPassword.EndPoint,
      headers: { "x-api-key": xApiKey, "x-api-iv": xApiIv },
      data: {
        email: email,
      },
    })
  }
  userResetPassword = async (
    email: string,
    newPassword: string,
    code: string,
  ) => {
    return this.instance({
      method: this.resetPassword.Method,
      url: this.resetPassword.EndPoint,
      headers: { "x-api-key": xApiKey, "x-api-iv": xApiIv },
      data: {
        email: email,
        new_password: newPassword,
        code: code,
      },
    })
  }

  adminLogin = async (data: any) => {
    return this.instance({
      method: this.loginConfig.Method,
      url: this.loginConfig.EndPoint,
      headers: {},
      data,
    })
  }

  assignPermission = async (token: string, data: any) => {
    return this.instance({
      method: this.assignPerm.Method,
      url: this.assignPerm.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    })
  }

  removePermission = async (token: string, data: any) => {
    return this.instance({
      method: this.removePerm.Method,
      url: this.removePerm.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    })
  }

  getUserRole = async (email: string) => {
    return this.instance({
      method: this.userRole.Method,
      url: this.userRole.EndPoint(email),
      headers: { "x-api-key": xApiKey, "x-api-iv": xApiIv },
      data: null,
    })
  }
}

export default AuthAPI
